import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromFaqStore from './faq-store.reducer';

export const selectFaqStoreState = createFeatureSelector<fromFaqStore.State>(fromFaqStore.faqStoreFeatureKey);

export const selectFaqVM = createSelector(selectFaqStoreState, (state) => {
    let filteredFaqGroups = state.filterValue
        ? state.faqs?.filter((faqGroup) => {
              return (
                  faqGroup.title.toLowerCase().includes(state.filterValue.toLowerCase()) ||
                  faqGroup.content?.filter((faq) => {
                      return faq.title.toLowerCase().includes(state.filterValue.toLowerCase()) || faq.content.toLowerCase().includes(state.filterValue.toLowerCase());
                  }).length > 0
              );
          })
        : state.faqs;

    if (state.filterValue) {
        filteredFaqGroups = filteredFaqGroups.map((faqGroup) => ({
            ...faqGroup,
            content: [...faqGroup.content?.filter((faq) => faq.content?.toLowerCase().includes(state.filterValue.toLowerCase()) || faq.title?.toLowerCase().includes(state.filterValue.toLowerCase()))],
        }));
    }

    return {
        faqGroups: state.faqs,
        filterValue: state.filterValue,
        filteredFaqGroups: filteredFaqGroups?.filter((faqGroup) => faqGroup.content.length > 0),
    };
});
